import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { BuscaPedidosAprov } from '../../components/BuscaPedidosAprov';
import { TabelaListaPedidosAprov } from '../../components/TabelaListaPedidosAprov';

export const AprovarPedidos = () => {
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <NavBar />
                <div className="main-content-aprovacao">
                    <span className="novo-pedido-title-form">Busca de Pedidos</span>
                    <BuscaPedidosAprov />
                    <span className="novo-pedido-title-form">Lista de Pedidos</span>
                    <TabelaListaPedidosAprov />
                </div>
            </div>
            <Toaster />
        </div>
    )
}